(function(){
  const SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  const SWIPER_event = 'loomish-swiper-loaded';

  function loadSwiperAssets(callback){
    if(window.Swiper){ callback(); return; }
    if(window.__loomishSwiperLoading){
      document.addEventListener(SWIPER_event, callback, { once: true });
      return;
    }
    window.__loomishSwiperLoading = true;
    const script = document.createElement('script');
    script.src = SWIPER_JS;
    script.async = true;
    script.addEventListener('load', function(){
      window.__loomishSwiperLoading = false;
      document.dispatchEvent(new Event(SWIPER_event));
      callback();
    });
    document.head.appendChild(script);
  }

  function destroySlider(section){
    if(!section) return;
    const swiper = section._loomishSwiper;
    if(swiper && typeof swiper.destroy === 'function'){
      swiper.destroy(true, true);
    }
    section._loomishSwiper = null;
  }

  function getSectionById(sectionId){
    return sectionId ? document.querySelector('#shopify-section-' + sectionId) : null;
  }

  function initSlider(section){
    if(!section || !section.classList.contains('loomish-slider-ad')) return;
    if(section._loomishSwiper){ destroySlider(section); }

    const container = section.querySelector('.loomish-slider-ad__swiper');
    const slides = section.querySelectorAll('.swiper-slide');
    if(!container || slides.length === 0) return;

    const autoplayEnabled = section.dataset.autoplay === 'true';
    const autoplaySpeed = Number(section.dataset.autoplaySpeed) * 1000 || 4000;
    const transitionSpeed = Number(section.dataset.transitionSpeed) || 600;
    const showArrows = section.dataset.showArrows === 'true';
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = autoplayEnabled && !prefersReduced;

    const config = {
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      loop: true,
      loopAdditionalSlides: 8,
      observer: true,
      observeParents: true,
      speed: prefersReduced ? Math.max(300, Math.round(transitionSpeed * 0.7)) : transitionSpeed,
      spaceBetween: 16,
      breakpoints: {
        640: {
          slidesPerView: 'auto',
          spaceBetween: 14
        },
        1024: {
          slidesPerView: 'auto',
          spaceBetween: -56
        },
        1440: {
          slidesPerView: 'auto',
          spaceBetween: -96
        }
      },
      coverflowEffect: {
        rotate: prefersReduced ? 0 : 16,
        stretch: 0,
        depth: prefersReduced ? 90 : 200,
        modifier: 1,
        scale: prefersReduced ? 0.96 : 0.9,
        slideShadows: false
      },
      autoplay: autoplay ? {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      } : false,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        slideLabelMessage: 'Slide {{index}} of {{slidesLength}}'
      },
      on: {
        init() {
          if(prefersReduced && this.autoplay){
            this.autoplay.stop();
          }
        }
      }
    };

    if(showArrows){
      config.navigation = {
        nextEl: section.querySelector('.loomish-slider-ad__nav--next'),
        prevEl: section.querySelector('.loomish-slider-ad__nav--prev')
      };
    }

    const swiper = new Swiper(container, config);
    section._loomishSwiper = swiper;
    swiper.update();
    window.addEventListener('load', function() { if(swiper) swiper.update(); }, { once: true });

    section.addEventListener('mouseenter', function(){
      if(swiper.autoplay && autoplay){
        swiper.autoplay.stop();
      }
    });

    section.addEventListener('mouseleave', function(){
      if(swiper.autoplay && autoplay){
        swiper.autoplay.start();
      }
    });
  }

  function initIfMine(root){
    if(!root) return;
    const section = root.classList && root.classList.contains('loomish-slider-ad') ? root : root.querySelector('.loomish-slider-ad');
    if(!section) return;
    loadSwiperAssets(function(){ initSlider(section); });
  }

  function destroyIfMine(root){
    if(!root) return;
    const section = root.classList && root.classList.contains('loomish-slider-ad') ? root : root.querySelector('.loomish-slider-ad');
    destroySlider(section);
  }

  function slideToBlock(event){
    const section = getSectionById(event.detail && event.detail.sectionId);
    const blockId = event.detail && event.detail.blockId;
    if(!section || !blockId) return;
    const swiper = section._loomishSwiper;
    if(!swiper) return;
    const slides = Array.from(section.querySelectorAll('.swiper-slide'));
    const targetIndex = slides.findIndex((slide) => slide.dataset.blockId === blockId);
    if(targetIndex >= 0){
      swiper.slideToLoop(targetIndex);
      if(swiper.autoplay && swiper.autoplay.running){
        swiper.autoplay.stop();
      }
    }
  }

  function resumeAutoplay(event){
    const section = getSectionById(event.detail && event.detail.sectionId);
    if(!section) return;
    const swiper = section._loomishSwiper;
    if(swiper && swiper.autoplay && section.dataset.autoplay === 'true'){
      swiper.autoplay.start();
    }
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.loomish-slider-ad').forEach(initIfMine);
  });

  document.addEventListener('shopify:section:load', function(event){ initIfMine(event.target); });
  document.addEventListener('shopify:section:unload', function(event){ destroyIfMine(event.target); });
  document.addEventListener('shopify:block:select', slideToBlock);
  document.addEventListener('shopify:block:deselect', resumeAutoplay);
})();
